import backIcon from '@/assets/img/home/back.png';
import { getStorage } from '@/utils';
import { NavBar, NavBarProps } from 'antd-mobile';
import { useNavigate, useSearchParams } from 'react-router-dom';

interface HeaderProps extends NavBarProps {
  title?: React.ReactNode;
}

const Header = ({ title, right, ...others }: HeaderProps) => {
  const paddingTop = getStorage('paddingTop') || 0;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const hideAppBar = searchParams.has('hideAppBar');

  if (hideAppBar) {
    return null;
  }
  return (
    <>
      <NavBar
        backArrow={
          <img
            src={backIcon}
            alt="1"
            style={{
              width: '23px',
              height: '23px',
              margin: 'auto 0',
              display: 'block',
            }}
          />
        }
        right={right}
        onBack={() => navigate(-1)}
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 2,
          height: paddingTop ? `${45 + Number(paddingTop)}px` : 45,
          paddingTop: paddingTop ? `${paddingTop}px` : 0,
        }}
        {...others}
      >
        <span
          style={{
            fontSize: '20px',
          }}
        >
          {title}
        </span>
      </NavBar>
    </>
  );
};

export default Header;
